export default __webpack_public_path__ + "static/media/38_BottomRightSquares_Flip.409f560d.mp4";